<template>
  <div class="view-container">
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      label-width="120px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider
        >{{ $t('ChannelManagement.new.title') }}
        <template #right>
          <BjLogButton
            v-if="isEdit"
            :id="form.id"
            permission="BusinessChannelOnlineList_Log"
            :title="form.name"
            api="channelApi"
          />
        </template>
      </BjDivider>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.name')" prop="name">
            <BjInput
              v-model="form.name"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <BjFormItemCode
            v-model="form.code"
            :readonly="isEdit"
            :label="$t('ChannelManagement.new.code')"
            prop="code"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.Channel')" prop="channelTypeCode">
            <BjSelectLov v-model="form.channelTypeCode" lov-code="SCHL.CHANNEL_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.Type')" prop="onlineStoreTypeCode">
            <BjSelectLov v-model="form.onlineStoreTypeCode" lov-code="SCHL.SHOP_TYPE" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.charge')" prop="manager">
            <BjInput
              v-model="form.manager"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.company')" prop="salesOrganizingId">
            <BjCompanyTreeSelect v-model="form.salesOrganizingId" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.Invoice')" prop="invoiceTypeCode">
            <BjSelectLov v-model="form.invoiceTypeCode" lov-code="SCHL.INVOICE_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('ChannelManagement.new.Associated')"
            prop="relationPhysicalShopId"
          >
            <!-- 已启用且是O2O订单自提的门店列表 -->
            <BjSelectStorePhysical
              v-model="form.relationPhysicalShopId"
              :default-params="{ status: true, selfPickupFlag: true }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.new.describe')" prop="description">
            <BjInput
              v-model="form.description"
              type="textarea"
              autosize
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.Header.taxCode')" prop="taxCode">
            <BjInputCode
              v-model="form.taxCode"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.Header.accountCode')" prop="accountCode">
            <BjInputCode
              v-model="form.accountCode"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.Header.currency')" prop="currency">
            <BjSelectLov v-model="form.currency" :option-list="CURRENCY_LIST" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelManagement.Header.project')" prop="project">
            <BjInput
              v-model="form.project"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('ChannelManagement.Header.typeOfFreight')"
            prop="autoTableStatus"
          >
            <BjSelectLov v-model="form.autoTableStatus" lov-code="FREIGHT_TYPE" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form-item :label="$t('ChannelManagement.Header.shippingCostAutoStatus')">
          <el-switch v-model="form.shippingCostAutoStatus" />
        </el-form-item>
      </el-col>
      <BjDivider
        >{{ $t('ChannelManagement.new.relateWarehouse') }}
        <!-- <template #right>
          <el-button type="primary" @click="addWarehouse"
            >{{ $t('addText') }}{{ $t('ChannelManagement.new.warehouse') }}</el-button
          >
        </template> -->
      </BjDivider>
      <el-col :span="24">
        <el-form-item :label="$t('ChannelManagement.new.warehouse')" prop="channelWarehouseId">
          <!-- <BjSelectWarehouse
            v-model="form.channelWarehouseName"
            :type-code="['channel']"
            clearable
          /> -->
          <BjSelectWarehouse
            ref="RefBjSelectWarehouse"
            v-model="form.channelWarehouseId"
            :type-code="['channel']"
            clearable
            @change="
              (v, item) => {
                form.channelWarehouseName = item.name;
              }
            "
          />
        </el-form-item>
      </el-col>

      <BjDivider>{{ $t('ChannelManagement.new.Store') }}</BjDivider>
      <el-col :span="24">
        <el-checkbox
          v-model="form.status"
          :checked="!isEdit"
          :label="$t('enableText')"
          disabled
        ></el-checkbox>
        <br />
        <el-checkbox
          v-model="form.autoDownloadGoods"
          :checked="!isEdit"
          :label="$t('ChannelManagement.new.products')"
        ></el-checkbox>
        <br />
        <el-checkbox
          v-model="form.autoPullOrder"
          :label="$t('ChannelManagement.new.orders')"
        ></el-checkbox>
        <div style="height: 40px; line-height: 40px">
          <el-checkbox
            v-model="form.autoSyncInventory"
            @change="form.syncSafeValue = syncSafeValue"
          >
            {{ $t('ChannelManagement.new.inventory') }}
            <span v-show="form.autoSyncInventory">
              <span style="font-size: 14px; color: #606266; padding: 0 10px">
                {{ $t('ChannelManagement.new.security') }}</span
              >
              <el-input-number
                v-model="form.syncSafeValue"
                :min="0"
                :precision="0"
                :controls="false"
                :label="$t('ChannelManagement.new.security')"
                style="width: 80px"
              />
              <br />
              <el-link type="danger" :underline="false" style="cursor: auto; margin-left: 10px">{{
                $t('ChannelManagement.new.Note')
              }}</el-link>
            </span>
          </el-checkbox>
        </div>
      </el-col>
    </BjDrawerForm>
  </div>
</template>
<script>
import { baseDataApi, channelApi, stockApi } from '@/api';

// 币种CODE
const LOVCODE = 'CHANNEL_CURRENCY';
const getDefaultForm = () => {
  return {
    autoDownloadGoods: true,
    autoPullOrder: false,
    autoSyncInventory: false,
    channelTypeCode: null,
    channelWarehouseName: null,
    channelWarehouseStatus: true, // 渠道仓状态默认启用
    code: null,
    description: null,
    id: null,
    invoiceTypeCode: null,
    manager: null,
    name: null,
    objectVersionNumber: null,
    onlineStoreTypeCode: null,
    relationPhysicalShopId: null,
    salesOrganizingId: null,
    status: true, // 状态默认启用
    syncSafeValue: 0,
    url: '',
    taxCode: null,
    accountCode: null,
    currency: null,
    autoTableStatus: '',
    shippingCostAutoStatus: false,
    project: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        name: [{ required: true, message: this.$t('ChannelManagement.new.ps'), trigger: 'blur' }],
        channelTypeCode: [
          { required: true, message: this.$t('ChannelManagement.new.ps1'), trigger: 'change' },
        ],
        onlineStoreTypeCode: [
          { required: true, message: this.$t('ChannelManagement.new.ps2'), trigger: 'change' },
        ],
        manager: [
          { required: true, message: this.$t('ChannelManagement.new.ps3'), trigger: 'blur' },
        ],
        salesOrganizingId: [
          { required: true, message: this.$t('ChannelManagement.new.ps4'), trigger: 'change' },
        ],
        invoiceTypeCode: [
          { required: true, message: this.$t('ChannelManagement.new.ps5'), trigger: 'change' },
        ],
        url: [{ required: true, message: this.$t('ChannelManagement.new.ps6'), trigger: 'change' }],
        channelWarehouseId: [
          { required: true, message: this.$t('ChannelManagement.new.ps7'), trigger: 'blur' },
        ],
        taxCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        accountCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        currency: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        autoTableStatus: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        project: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      CURRENCY_LIST: [],
      syncSafeValue: 0,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getLovCode();
  },
  methods: {
    // 获取币种值集
    async getCurrencyList(id) {
      // 币种ID
      const res = await baseDataApi.getLovValuesByLovId({ lovId: id });
      this.CURRENCY_LIST = res.content.map(item => {
        return {
          label: item.meaning,
          value: item.meaning,
        };
      });
    },
    getLovCode() {
      baseDataApi.getLovHeadersByLovCode({ lovCode: LOVCODE }).then(res => {
        if (res.lovId) {
          this.getCurrencyList(res.lovId);
        }
      });
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit ? this.$t('ChannelManagement.new.edit') : this.$t('ChannelManagement.new.NEW'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
      this.form.autoTableStatus = String(this.form.autoTableStatus);
      this.syncSafeValue = this.form.syncSafeValue;
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      API_DATA.autoSyncInventory ? '' : delete API_DATA.syncSafeValue;
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      channelApi.saveOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    addWarehouse() {
      this.$prompt(this.$t('ChannelManagement.new.ps8'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        inputValidator: v => !!v,
        inputErrorMessage: this.$t('emptyWarningText'),
      })
        .then(({ value }) => {
          stockApi
            .saveChannelWarehouses({
              name: value,
              typeCode: 'channel',
            })
            .then(res => {
              if (
                res.id ||
                res._token ||
                res.content ||
                Array.isArray(res) ||
                res.failed === false
              ) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.$refs.RefBjSelectWarehouse.get();
                }, 500);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('toast.cancelText'),
          });
        });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
